import styled from '@emotion/styled';

export const Wrapper = styled.div`
  display: flex;
  max-width: 750px;
  flex-direction: column;
`;
